const riot = require('riot');

riot.tag2('atom-frontmatter-table', '<div class="py8 f flex-column"> <div class="f fm prop-row py2 px2" each="{entry in entries}" key="{entry.key}"> <div class="w80 fs12 text-label_dark_medium flex-fixed line-clamp-1 mr8" title="{entry.key}">{entry.key}</div> <input class="fs12 bg-transparent border-none outline-none px4 py2 rounded-4 prop-input" type="text" riot-value="{parent.getDisplayValue(entry.value)}" onblur="{parent.onValueBlur}" onkeydown="{parent.onValueKeydown}"> <button class="flex-fixed f fh w16 h16 text-label_dark_disabled hover-text-label_dark transition ml4 prop-remove" type="button" onclick="{parent.onRemove}" aria-label="プロパティを削除" title="プロパティを削除"><i class="icon-close fs12"></i></button> </div> </div>', 'atom-frontmatter-table,[data-is="atom-frontmatter-table"]{display:block;width:100%;border-top:1px solid rgba(29,40,76,0.15);border-bottom:1px solid rgba(29,40,76,0.15)} atom-frontmatter-table .prop-row .prop-input,[data-is="atom-frontmatter-table"] .prop-row .prop-input{flex:1;min-width:0} atom-frontmatter-table .prop-row .prop-input:hover,[data-is="atom-frontmatter-table"] .prop-row .prop-input:hover{background-color:rgba(29,40,76,0.03)} atom-frontmatter-table .prop-row .prop-remove,[data-is="atom-frontmatter-table"] .prop-row .prop-remove{opacity:0;transition:opacity .15s} atom-frontmatter-table .prop-row:hover .prop-remove,[data-is="atom-frontmatter-table"] .prop-row:hover .prop-remove,atom-frontmatter-table .prop-row .prop-remove:focus-visible,[data-is="atom-frontmatter-table"] .prop-row .prop-remove:focus-visible{opacity:1}', '', function(opts) {
    this.getEntries = (data) => {
      return Object.keys(data || {}).map(key => ({ key, value: data[key] }));
    };

    this.entries = this.getEntries(this.opts.data);

    this.getDisplayValue = (value) => {
      if (Array.isArray(value)) {
        return value.map(v => String(v)).join(', ');
      }
      if (value === null || value === undefined) return '';
      return String(value);
    };

    this.parseValue = (key, raw) => {
      const original = this.opts.data?.[key];
      if (Array.isArray(original)) {
        return raw.split(',').map(s => s.trim()).filter(s => s.length > 0);
      }
      return raw;
    };

    this.on('update', () => {
      this.entries = this.getEntries(this.opts.data);
    });

    this.onValueBlur = (e) => {
      const { entry } = e.item;
      const new_value = this.parseValue(entry.key, e.target.value);
      if (_.isEqual(entry.value, new_value)) return;
      this.opts.onChange({ ...this.opts.data, [entry.key]: new_value });
    };

    this.onValueKeydown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.target.blur();
      }
    };

    this.onRemove = (e) => {
      e.preventDefault();
      const { entry } = e.item;
      const new_data = { ...this.opts.data };
      delete new_data[entry.key];
      this.opts.onChange(new_data);
    };
});